import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './ToolTrademark.css';
import PageTitle from '../Layout/components/PageTitle';
import { Button, Paper, Breadcrumbs, Link, Typography } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import { Photo } from '@material-ui/icons';
import { conver } from '../../common/utils';
import Axios from 'axios';
import Dropzone from 'react-dropzone'

class ToolTrademark extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            fileName: "",
            fileSize: "",
            fileState: 0,
            fileData: null,
            downloadUrl: ""
        }
        this.handleDel = this.handleDel.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
    }
    render() {
        const {
            fileName,
            fileSize,
            fileState,
            fileData,
            downloadUrl
        } = this.state;
        const downloadView = () => {
            if (downloadUrl) {
                return <div className="down-btn" onClick={this.handleDownload}>Download</div>
            }
        }
        const uploadView = () => {
            if (fileData) {
                return <div className="upload-wapper v">
                    <div className="file-list f">
                        <table className="table" cellPadding={10}>
                            <thead>
                                <tr>
                                    <th width="20%">File Name</th>
                                    <th width="20%">Size</th>
                                    <th width="20%">State</th>
                                    <th width="20%">Operation</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td align="center">
                                        <div className="h h-c">
                                            <div className="img c"><Photo /></div>
                                            <div>{fileName}</div>
                                        </div>
                                    </td>
                                    <td align="center">{conver(fileSize)}</td>
                                    <td align="center">{this.stateToStr(fileState)}</td>
                                    <td align="center">
                                        <div className="h h-c">
                                            <div className="del-btn" onClick={this.handleDel}>Delete</div>
                                            {downloadView()}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="toolbar h h-bt">
                        <div><b>Total 1 file</b></div>
                        <div className="h">
                            <Button variant="contained" className="mr-10" onClick={this.handleBack}>back</Button>
                            <Button variant="contained" color="primary" onClick={this.handleUpload}>upload</Button>
                        </div>
                    </div>
                </div>
            } else {
                return <Dropzone onDrop={this.handleDrop} accept="image/*" multiple={false}>
                    {({ getRootProps, getInputProps }) => (
                        <section>
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <div className="upload-wapper c">
                                    <div className="upload-title">Trademark image tool</div>
                                    <div className="upload-subtitle">Choose a picture or drag the picture here</div>
                                    <label htmlFor="icon-button-file">
                                        <Button variant="contained" color="primary" component="span">
                                            select image
                                        </Button>
                                    </label>
                                </div>
                            </div>
                        </section>
                    )}
                </Dropzone>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" href="/main/smarttools">All Smart Tools</Link>
                            <Typography className="crtTitle">Trademark Image Tool</Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <Paper className="wapper">
                    {uploadView()}
                </Paper>
            </Root>
        );
    }
    componentDidMount() {

    }
    handleDel(e) {
        this.clearFile();
    }
    handleUpload(e) {
        this.setState(() => ({
            fileState: 1
        }));
        this.uploadFile(this.state.fileData);
    }
    handleDownload(e) {
        this.downloadFile(this.state.downloadUrl);
    }
    handleBack(e) {
        this.clearFile();
    }
    handleDrop(files) {
        const file = files[0];
        if (!file) return;
        const fileName = file.name ? file.name : "";
        const fileSize = file.size ? file.size : "";
        const fileData = file;
        this.setState(() => ({
            fileName,
            fileSize,
            fileData
        }));
    }
    stateToStr(state) {
        if (state === 0) {
            return "Ready to upload"
        } else if (state === 1) {
            return "Uploading..."
        } else if (state === 2) {
            return "Upload successfully"
        }
    }
    clearFile() {
        this.setState(() => ({
            fileName: "",
            fileSize: "",
            fileData: null,
            downloadUrl: ""
        }));
    }
    uploadFile(file) {
        const data = new FormData();
        data.append('file', file);
        Axios({
            url: BASE_URL + "tool/image/resize",
            method: "post",
            data,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": "Bearer " + window.localStorage.getItem("token")
            },
        }).then(res => {
            console.log(res)
            if (res.data.error === 0) {
                const downloadUrl = res.data.data.url;
                this.setState(() => ({
                    fileState: 2,
                    downloadUrl
                }));
            }
        }).catch(err => {
            alert("Upload failed");
        })
    }
    downloadFile(imgsrc) {
        window.location.href = imgsrc;
    }
}

export default withRouter(ToolTrademark);